import { applyMetricScopeFilters } from './metricScopeFilters';
import { METRIC_SCOPES } from '../../utils/eventAttribution';

/** Stable row key for deduping share/download events across feed + timeseries. */
export const sharingActivityRowId = (row) =>
  row?._id || `${row?.timestamp}-${row?.meta?.user}-${row?.meta?.event}`;

/** Dedupe by id and sort newest first (drill-down list + KPI totals). */
export const dedupeSharingActivityRows = (rows) => {
  const byId = new Map();
  (rows || []).forEach((r) => {
    const id = sharingActivityRowId(r);
    if (!byId.has(id)) byId.set(id, r);
  });
  return [...byId.values()].sort(
    (a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0)
  );
};

/**
 * Full-window raw rows for one event, after demand-scope + internal filters.
 */
export const buildFilteredSharingRows = (rawRows, filterOpts = {}) =>
  dedupeSharingActivityRows(
    applyMetricScopeFilters(rawRows, {
      scope: METRIC_SCOPES.demand,
      excludeAgentActivity: filterOpts.excludeAgentActivity ?? false,
      ...filterOpts,
    })
  );
